var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02451 0.167368C7.24767 -0.0557892 7.60947 -0.0557892 7.83263 0.167368C8.05579 0.390524 8.05579 0.752333 7.83263 0.975489L4.80812 4L7.83264 7.02451C8.05579 7.24767 8.05579 7.60947 7.83264 7.83263C7.60948 8.05579 7.24767 8.05579 7.02452 7.83263L4 4.80812L0.975489 7.83263C0.752333 8.05579 0.390524 8.05579 0.167368 7.83263C-0.0557893 7.60947 -0.0557893 7.24766 0.167368 7.02451L3.19188 3.99999L0.167376 0.975489C-0.0557812 0.752333 -0.0557812 0.390524 0.167376 0.167368C0.390532 -0.0557891 0.752341 -0.0557891 0.975497 0.167368L4 3.19187L7.02451 0.167368Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5354528116efb5dd2cfeb5d7b5ed3548.svg";
export { ForwardRef as ReactComponent };